import React, { Component, } from 'react'
import { Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, } from 'reactstrap'
import { db } from '../../config/firebaseconfig'
import timestamper from '../../helpers/timestamper'
import queryString from 'query-string'
import getRequest from '../../helpers/getRequest';
import addUser from '../../helpers/users/addUser';


const uuid = require('uuid/v1')


/* 
ManageEducators

  <AddDistrictAdminsModal
    isOpen={this.props.modal === 'addDistrictAdmin'}
    toggle={this.props.closeModal}
    key='AddDistrictAdminsModal'
    select={this.props.select}
    selectedDistrict={this.props.selection.district}
    districts={this.props.districts}
  />

*/

class AddDistrictAdminsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      sfid: '',
      isSaving: false,
      error: '',
      manualAdd: false,
    }

    this.updateState = this.updateState.bind(this)
    this.cancel = this.cancel.bind(this)

    this.input = React.createRef()
  }

  updateState(obj) {
    this.setState(obj)
  }
  
  toggleManualAdd() {
    this.setState({
      manualAdd: !this.state.manualAdd,
    })
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  cancel() {
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      sfid: '',
      isSaving: false,
      error: '',
      manualAdd: false,
    })
    this.props.toggle()
  }

  addDistrictAdmin() {
    addUser(this.state, this.updateState, 'District Admin', this.props, this.cancel)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.input.current.focus()
    }
  }

  handleKeyPress(key) {
    if (key === 'Enter' && !this.state.isSaving) {
      this.addDistrictAdmin()
    }
  }

  render() {
    let passwordFormGroup = null
    if (this.state.manualAdd) {
      passwordFormGroup = (
        <FormGroup>
          <Label htmlFor='password'>Password</Label>
          <Input 
            type='text' 
            id='password' 
            name='password' 
            placeholder='password123' 
            onChange={(e) => this.handleChange(e)} 
            value={this.state.password}
            className={this.state.error === 'Password is required.' && !this.state.password ? 'is-invalid' : null}              
          />
        </FormGroup>
      )
    }

    let submitButton = <Button className={'ml-2'} color='success' onClick={() => this.addDistrictAdmin()}>{this.state.manualAdd ? 'Create Account' : 'Send Invite'}</Button>
    if (this.state.isSaving) {
      submitButton = <Button className={'ml-2'} color='success'><i className="fa fa-spinner fa-lg fa-spin"></i></Button>
    }


    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={'modal-success'}>
        <ModalHeader toggle={this.props.toggle}>Add District Admin</ModalHeader>
        <ModalBody>
          <Form onKeyPress={(e) => this.handleKeyPress(e.key)}>
            <FormGroup>
              <Label htmlFor='firstName'>First Name</Label>
              <Input 
                type='text' 
                id='firstName' 
                name='firstName' 
                placeholder='Joe' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.firstName}
                className={this.state.error === 'First name field is required.' && !this.state.firstName ? 'is-invalid' : null}              
                innerRef={this.input}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='lastName'>Last Name</Label>
              <Input 
                type='text' 
                id='lastName' 
                name='lastName' 
                placeholder='Adminius' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.lastName}
                className={this.state.error === 'Last name field is required.' && !this.state.lastName ? 'is-invalid' : null}              
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='email'>Email</Label>
              <Input 
                type='text' 
                id='email' 
                name='email' 
                placeholder='joeadminius@gmail.com' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.email}
                className={
                  this.state.error === 'Email is required.' || this.state.error === 'Email invalid.' 
                  ? 'is-invalid' 
                  : null
                }              
              />
            </FormGroup>
            {passwordFormGroup}
            <FormGroup>
              <Label htmlFor='sfid'>SF Id</Label>
              <Input
                type='text'
                id='sfid'
                name='sfid'
                placeholder='001i000000Jdw9d'
                onChange={(e) => this.handleChange(e)}
                value={this.state.sfid}
              />
            </FormGroup>
            <Label className="switch switch-3d switch-primary">
              <Input 
                type="checkbox" 
                className="switch-input" 
                checked={this.state.manualAdd} 
                onClick={() => this.toggleManualAdd()}/>
              <span className="switch-label"></span>
              <span className="switch-handle"></span>
            </Label> Manually Create Password
          </Form>
        </ModalBody>
        <ModalFooter>
          {this.state.error ? `${this.state.error}` : ''}
          {submitButton}
          <Button onClick={() => this.cancel()} color='secondary'>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddDistrictAdminsModal



// WEBPACK FOOTER //
// ./src/components/Users/AddDistrictAdminsModal.js